module.exports = __webpack_public_path__ + "static/before2-800c5c9398642c3e70984af38df68b12.jpg";